import { render, staticRenderFns } from "./NovaFaltaJustificadaPage.vue?vue&type=template&id=8e6e4b78"
import script from "./NovaFaltaJustificadaPage.vue?vue&type=script&lang=js"
export * from "./NovaFaltaJustificadaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports